import { styled } from "styled-components";

export const ItensContainer = styled.div`
    background: #F6F6FC;
    display: flex;
    justify-content: center;
    width: calc(100% - 260px);
    border-radius: 40px 0px 0px 40px;

  .box {
    margin-top: 40px;
    width: 90%;
    height: 700px;
    background-color: #F6F6FC;
    border-radius: 18px;
  }

  .flex{
    display: flex;
    align-items: center;
  }

  h1 {
    font-size: 50px;
    font-weight: 600;
    margin-top: 4px;
    margin-left: 10px;
    color: var(--principal);
  }

  .filtro {
    display: flex;
    align-items: center;
    gap: 20px;
    width: 45%;

    input {
      font-size: 14px;
      border: none;
      padding: 10px;
      border-radius: 50px;
      width: 70%;
      height: 40px;
    }

    div {
      align-items: center;
      justify-content: center;
      display: flex;
      flex-direction: column;
      margin-bottom: 25px;
      width: 35%;

      > p {
        font-size: 0.8rem;
        margin-bottom: 8px;
      }
    }

    select,
    option {
      width: 161px;
      padding: 5px;
      border-radius: 6px;
      border: none;
      outline: none;
      background: var(--amarelo);
      text-align: center;
      font-size: 0.8rem;
      color: var(--base);
      font-weight: 200;
    }
  }

  .icone{
    width: 45px;
    height: 45px;
    
    svg{
      width: 45px;
      height: 45px;
    }
  }
`;

export const BoxFiltros = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  button {
    background-color: var(--principal);
    color: var(--base);
    width: 20%;
    font-size: 0.8rem;
    font-weight: 600;
    padding: 8px;
    border: none;
    border-radius: 20px;
  }
`;
